import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Tooltip,
  TableHead,
  TableRow,
  Input,
  TablePagination,
  Typography,
  IconButton,
  Button,
  Stack,
  Box,
} from "@mui/material";
import { ProcessNotesAlarmsColumns } from "./columns";
import { AddNewPlantNoteDialog } from "popup/AddNewPlantNoteDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { tlmDeletePlantNote } from "layouts/dashboard/apiService";
import NoData from "components/NoData";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import AddIcon from "@mui/icons-material/Add"; // Import dell'icona Add
import {
  tlmPostPinPlantNote,
  tlmGetPlantNotes,
} from "layouts/dashboard/apiService";
import { APIStatusDialog } from "components/APIStatusDialog";
import { I18n } from "@aws-amplify/core";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useRefresh } from "layouts/dashboard/RefreshContext";
export const RenderProcessNote = ({
  deviceProscessState,
  resourcePrefPagePro,
  rowsPerResourcePrefPagePro,
  setResourcePrefPagePro,
  setRowsPerResourcePrefPagePro,
  account_number,
  endDate,
  startDate,
  dispatchProcessPlant,
  setStartDate,
  setEndDate,
  profile,
}) => {
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const isGuest = profile && profile.includes("Guest");
  const formatTimestamp = (timestamp) =>
    dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");
  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const toolbarRef = useRef(null);
  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const plantNotesColumns = ProcessNotesAlarmsColumns();
  const {handleRefresh}=useRefresh();
  const handlePinClick = async (noteID, currentPinnedValue) => {
    const newPinnedValue = !currentPinnedValue;
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Pinning"),
      });
      const restOperation = await tlmPostPinPlantNote(noteID, newPinnedValue);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Pinned successfully"),
        });
        const plantNoteResponse = await tlmGetPlantNotes(
          account_number,
          endDate,
          startDate
        );
        dispatchProcessPlant({
          type: "DATA_RECEIVED",
          value: plantNoteResponse,
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error Pinned"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error Pinned"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  const handleDeleteNote = async (noteID) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Deleting process note"),
      });
      const restOperation = await tlmDeletePlantNote(noteID);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Process Note deleted successfully"),
        });
        const response = await tlmGetPlantNotes(
          account_number,
          endDate,
          startDate
        );
        dispatchProcessPlant({ type: "DATA_RECEIVED", value: response });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error deleting process note"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error deleting process note"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };
  if (!deviceProscessState.data || deviceProscessState.data.length === 0) {
    return (
      <Card sx={{marginBottom:"1rem"}}>
         <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem 0"} }}>
          <Stack
            spacing={2}
            direction={tableParentIsMD ? "column" : "row"}
            alignItems="center"
            sx={{ pb: 2 }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label={I18n.get("Start Date")}
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                  format="YYYY/MM/DD"
                  maxDate={dayjs()} 
                renderInput={(params) => (
                  <Input {...params} fullWidth={tableParentIsMD} />
                )}
              />
              <DatePicker
                label={I18n.get("End Date")}
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                  format="YYYY/MM/DD"
                  maxDate={dayjs()} 
                renderInput={(params) => (
                  <Input {...params} fullWidth={tableParentIsMD} />
                )}
              />
            </LocalizationProvider>
            <Box
              sx={{
                ml: 2,
                flexGrow: 1,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography variant="h5">{I18n.get("Process Note")}</Typography>
            </Box>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
        <AddNewPlantNoteDialog
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          accountNumber={account_number}
          dispatchProcessPlant={dispatchProcessPlant}
          startDate={startDate}
          endDate={endDate}
        />
        <APIStatusDialog
          open={apiStatus.open}
          status={apiStatus.status}
          message={apiStatus.message}
        />
      </Card>
    );
  }
  return (
    <Card sx={{marginBottom:"1rem"}}>
       <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem 0"} }}>
        <Stack
          spacing={2}
          direction={tableParentIsMD ? "column" : "row"}
          alignItems="center"
          sx={{ pb: 2 }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={I18n.get("Start Date")}
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
                format="YYYY/MM/DD"
                maxDate={dayjs()} 
              renderInput={(params) => (
                <Input {...params} fullWidth={tableParentIsMD} />
              )}
            />
            <DatePicker
              label={I18n.get("End Date")}
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
                format="YYYY/MM/DD"
                maxDate={dayjs()} 
              renderInput={(params) => (
                <Input {...params} fullWidth={tableParentIsMD} />
              )}
            />
          </LocalizationProvider>
          <Box
            sx={{
              ml: 2,
              flexGrow: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography variant="h5"> {I18n.get("Process Note")}</Typography>
          </Box>
        </Stack>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {plantNotesColumns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {deviceProscessState.data
                .slice(
                  resourcePrefPagePro * rowsPerResourcePrefPagePro,
                  resourcePrefPagePro * rowsPerResourcePrefPagePro +
                    rowsPerResourcePrefPagePro
                )
                .map((mappingRow, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {plantNotesColumns.map((column, colIndex) => (
                      <TableCell key={colIndex} sx={{padding:"0px"}}>
                        {column.id === "timestamp" ? (
                          formatTimestamp(mappingRow[column.id]) // Apply timestamp formatting here
                        ) : column.id === "pinned" ? (
                          <IconButton
                            onClick={() =>
                              handlePinClick(mappingRow.id, mappingRow.pinned)
                            }
                            disabled={isGuest}
                          >
                            {mappingRow.pinned ? (
                              <PushPinIcon />
                            ) : (
                              <PushPinOutlinedIcon />
                            )}
                          </IconButton>
                        ) : column.id === "action" ? (
                          <IconButton
                            onClick={() => handleDeleteNote(mappingRow.id)}
                            disabled={isGuest} // Disables delete button if user is guest
                          >
                            <DeleteIcon /> {/* Display delete icon */}
                          </IconButton>
                        ) : mappingRow[column.id] !== undefined &&
                          mappingRow[column.id] !== null ? (
                          mappingRow[column.id]
                        ) : (
                          ""
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={deviceProscessState.data.length}
          page={resourcePrefPagePro}
          onPageChange={(event, newPage) => setResourcePrefPagePro(newPage)}
          rowsPerPage={rowsPerResourcePrefPagePro}
          onRowsPerPageChange={(event) => {
            setRowsPerResourcePrefPagePro(parseInt(event.target.value, 10));
            setResourcePrefPagePro(0);
          }}
          rowsPerPageOptions={[]}
        />
      </CardContent>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
      <AddNewPlantNoteDialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        accountNumber={account_number}
        dispatchProcessPlant={dispatchProcessPlant}
        startDate={startDate}
        endDate={endDate}
      />
    </Card>
  );
};
